import { SlackChannelsConfig } from 'src/features/slack/data/service/SlackNotificationsService.types';

export const SLACK_CHANNEL_WEBHOOKS: SlackChannelsConfig = {
  'tech-app-notifications':
    'https://hooks.slack.com/services/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',
};
